import { createAsyncThunk } from '@reduxjs/toolkit';
import { HARDCODED_ISSUES } from '../data/issues.js';

export const searchIssues = createAsyncThunk(
  'issues/searchIssues',
  async (searchTerm, { rejectWithValue }) => {
    try {
      if (!searchTerm.trim()) {
        return HARDCODED_ISSUES;
      }

      const searchTermLower = searchTerm.toLowerCase();
      return HARDCODED_ISSUES.filter(issue =>
        issue.searchTerms.some(term => term.includes(searchTermLower)) ||
        issue.name.toLowerCase().includes(searchTermLower) ||
        issue.description.toLowerCase().includes(searchTermLower) ||
        issue.category.toLowerCase().includes(searchTermLower)
      );

    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
